import React from 'react';
import PropTypes from 'prop-types';

export const DownloadIcon = ({width=24, height=24, color='white'}) => {
    return (
        <svg width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path fillRule='evenodd' clipRule='evenodd' d='M9.5 5H14.5V10H18L12 16L6 10H9.5V5ZM18 19V17H6V19H18Z' fill={color}/>
        </svg>
    );
}

DownloadIcon.displayName = 'DownloadIcon';
DownloadIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string
};
